/** @jsx jsx */
import { QueryLazyOptions } from '@apollo/react-hooks'
import { css, jsx } from '@emotion/core'
import { Cell, colors, Grid, HFlow, Text } from 'bold-ui'
import { RegistrosDoseQueryVariables } from 'graphql/types.generated'
import { ImunobiologicoRowModel } from 'view/atendimentos/atendimento-vacinacao/model'

import { InfoCardModalVacinacao } from '../../vacinacao/VacinacaoCalendarioView'
import { DoseItem } from './DoseItem'

export interface ImunobiologicoRowProps {
  mostrarCalendarioCompleto: boolean
  model: ImunobiologicoRowModel
  handleOnDoseClicked: (info: InfoCardModalVacinacao) => void
  registrosDoseLazyQuery: (options?: QueryLazyOptions<RegistrosDoseQueryVariables>) => void
}

export function ImunobiologicoRow(props: ImunobiologicoRowProps) {
  const { mostrarCalendarioCompleto, model, handleOnDoseClicked, registrosDoseLazyQuery } = props
  const { nome, doses } = model

  return (
    <HFlow
      alignItems='center'
      style={css`
        background-color: ${colors.gray.c90};
        padding: 0.5rem 0rem;
        min-height: 5.25rem;
      `}
    >
      <Text
        fontWeight='bold'
        style={css`
          margin-left: 1rem;
          margin-right: 1rem;
          width: 6.25rem;
        `}
      >
        {nome}
      </Text>
      <Grid gap={0.5} gapVertical={0.5}>
        {doses.map((value) => {
          return (
            (value.model.mostrarNoCalendarioDoGrupo || mostrarCalendarioCompleto) && (
              <Cell
                key={value.model.calendarioId}
                xs={3}
                style={css`
                  min-height: 4.25rem;
                  width: 9.625rem;
                `}
              >
                <DoseItem
                  {...value}
                  handleOnDoseClicked={handleOnDoseClicked}
                  registrosDoseLazyQuery={registrosDoseLazyQuery}
                />
              </Cell>
            )
          )
        })}
      </Grid>
    </HFlow>
  )
}
